const es = {
  nav: {
    product: "Producto",
    howItWorks: "Cómo funciona",
    integrations: "Integraciones",
    pricing: "Precios",
    enterprise: "Enterprise",
    faq: "FAQ",
    signIn: "Iniciar sesión",
    getStarted: "Empieza gratis — $49 en créditos",
  },
  hero: {
    badge: "Nativo de Salesforce · Creado por DulipTech",
    line1: "Lanza agentes de IA",
    line2: "dentro de Salesforce.",
    line3: "Siempre un paso adelante.",
    sub: "Gyeno es la plataforma nativa de Salesforce para construir, probar y desplegar agentes de IA directamente en la org que tu equipo ya usa. Sin nuevo stack. Sin suscripción.",
    ctaPrimary: "Empieza gratis — solo $49 en créditos",
    ctaSecondary: "Hablar con ventas",
    thinking: "El agente está pensando…",
    caption: "Gyeno Studio — Diseña, prueba y lanza agentes de IA en Salesforce.",
  },
  trust: {
    builtFor: "Hecho para Salesforce",
    native: "Nativo en tu org",
    byDulip: "Desarrollado por DulipTech — consultoría Salesforce y productos de IA",
    regions: "Disponible en US · UK · Oriente Medio · APAC",
  },
  manifesto: {
    kicker: "El principio Gyeno",
    ch1t: "Tu Salesforce es la plataforma.",
    ch1b: "Los agentes no deberían vivir en una app aparte que tengas que conectar. Gyeno se vincula directamente con la lógica Apex y Flow de tu org y funciona dentro de Salesforce — donde ya están tus datos y tu equipo.",
    ch2t: "Construye gratis. Paga por uso.",
    ch2b: "Construir agentes es ilimitado y gratis — para siempre. No hay suscripción. Compras AI Credits desde $49 y solo se consumen cuando tus agentes realmente funcionan.",
    ch3t: "La confianza es una funcionalidad.",
    ch3b: "Action Runs, Policy Violations, Error Logs, Health — cada decisión del agente es observable y gobernada dentro del modelo de permisos de tu org. El control enterprise no es un extra.",
  },
  how: {
    kicker: "Cómo funciona",
    title: "Del lienzo en blanco al agente en vivo en tres pasos.",
    s1t: "Empieza en el Studio",
    s1b: "Regístrate y usa agentes predefinidos desde el primer día — o empieza un agente nuevo desde cero en Gyeno Studio, dentro de Salesforce.",
    s2t: "Ensambla acciones reales, elige tu LLM",
    s2b: "Combina workflows por etapas con las acciones Apex y Flow de tu propia org — GetPipeline, FindStalledDeals, LogTask — sin código. Elige Claude, GPT o Gemini por agente.",
    s3t: "Prueba en vivo, luego publica",
    s3b: "Chatea con tu agente en la Test Console en vivo antes que nadie. Publica versiones controladas con notas — itera con seguridad, revierte fácil.",
    cta: "Ver el recorrido completo",
  },
  features: {
    kicker: "Por qué los equipos eligen Gyeno",
    title: "Todo lo que necesitas. Nada que tengas que vigilar.",
    f1t: "Agent Builder gratuito e ilimitado",
    f1b: "Construye tantos agentes de IA como necesites — crear agentes siempre es gratis.",
    f2t: "14 días de soporte premium",
    f2b: "Cada cuenta nueva recibe dos semanas de ayuda práctica de implementación para tu caso de uso. Ingenieros reales, no documentación genérica.",
    f3t: "Elección de LLMs líderes",
    f3b: "Trae el modelo en el que confías: Claude, OpenAI GPT y Google Gemini — cambia por agente, sin lock-in.",
    f4t: "Entrada simple y de bajo coste",
    f4b: "Sin suscripción. Empieza con una compra única mínima de $49 en AI Credits — paga solo lo que tus agentes usan.",
    f5t: "Agentes predefinidos listos para usar",
    f5b: "Lanza con agentes preconstruidos desde el primer día — plug-and-play, sin arranque en frío.",
    f6t: "Bring-Your-Own-Key (Enterprise)",
    f6b: "Conecta las claves y contratos LLM de tu empresa para control total de costes y datos.",
  },
  channels: {
    kicker: "Despliega en cualquier lugar",
    title: "Un agente. Todos los canales que usan tus clientes.",
    whatsapp: "Meta Cloud API, directo — recibe y responde en WhatsApp.",
    instagram: "Atiende clientes en los DMs de Instagram.",
    teams: "Lleva agentes a Microsoft Teams.",
    slack: "Responde donde trabaja tu equipo — Slack.",
    web: "Widget integrable para cualquier web app.",
  },
  pricingTeaser: {
    title: "Sin suscripción. Paga solo lo que usas.",
    sub: "Construir agentes es gratis e ilimitado. Activa con una compra única mínima de $49 — los créditos solo se consumen cuando los agentes funcionan.",
    cta: "Ver precios",
  },
  proof: {
    kicker: "La confianza de equipos Salesforce",
    placeholder: "Logo de cliente",
  },
  entCallout: {
    title: "¿Escala enterprise? Trae tu propia clave LLM.",
    sub: "Conecta los contratos Claude, OpenAI o Gemini de tu organización para control total de costes y datos — con implementación del equipo DulipTech.",
    cta: "Contáctanos",
  },
  footer: {
    tagline: "Just One Step Ahead.",
    product: "Producto",
    company: "Empresa",
    legal: "Legal",
    privacy: "Política de privacidad",
    terms: "Términos y condiciones",
    contact: "Contacto",
    signup: "Registrarse",
    regions: "Disponible en US, UK, Oriente Medio y APAC.",
    rights: "© 2026 DulipTech. Todos los derechos reservados.",
    builtBy: "Gyeno está desarrollado por DulipTech.",
  },
  cookie: {
    text: "Usamos cookies para operar este sitio y, con tu consentimiento, para medir su uso. Consulta nuestra",
    accept: "Aceptar todas",
    reject: "Solo esenciales",
  },
  auth: {
    signupTitle: "Crea tu cuenta de empresa",
    signupSub: "Los agentes predefinidos gratis te esperan. Activa con $49 en créditos cuando quieras.",
    fullName: "Nombre completo",
    email: "Email de empresa",
    password: "Contraseña",
    company: "Nombre de la empresa",
    country: "País / Región",
    sfOrg: "Tipo de org de Salesforce (opcional)",
    createAccount: "Crear cuenta",
    haveAccount: "¿Ya tienes cuenta?",
    signIn: "Iniciar sesión",
    loginTitle: "Bienvenido de nuevo",
    loginSub: "Inicia sesión en tu cuenta de Gyeno.",
    noAccount: "¿Nuevo en Gyeno?",
    signUp: "Regístrate",
  },
  pricingPage: {
    kicker: "Precios",
    title: "Sin suscripciones. Solo AI Credits.",
    sub: "Todo lo relacionado con construir es gratis. Solo pagas lo que tus agentes usan — desde una compra única mínima de $49.",
    freeTitle: "Construcción de agentes",
    freeDesc: "Agentes ilimitados, ediciones ilimitadas, el Studio completo — gratis para siempre.",
    freeTag: "Gratis",
    predefTitle: "Agentes predefinidos",
    predefDesc: "Agentes preconstruidos listos desde el primer día. Sin arranque en frío.",
    predefTag: "Gratis",
    creditsTitle: "AI Credits",
    creditsDesc: "Una compra única mínima de $49 activa tu cuenta. Los créditos se consumen por uso real — llamadas LLM y acciones.",
    creditsTag: "Desde $49",
    supportNote: "Cada cuenta nueva incluye 14 días de soporte premium de implementación.",
    tableTitle: "Tarifas de consumo de créditos",
    tableNote: "Las tarifas finales se están definiendo y se publicarán aquí.",
    tableCol1: "Operación",
    tableCol2: "Créditos",
    row1: "Llamada LLM (modelo estándar)",
    row2: "Llamada LLM (modelo premium)",
    row3: "Ejecución de acción Salesforce",
    row4: "Mensaje de canal (WhatsApp / Teams / Slack)",
    tbd: "Por definir",
    calcTitle: "Elige tus créditos iniciales",
    calcSub: "Mínimo $49 — recarga cuando quieras.",
    calcCredits: "créditos",
    cta: "Regístrate y compra créditos",
    entTitle: "¿Necesitas tus propias claves LLM o un contrato a medida?",
    entSub: "BYOK enterprise, precios por volumen e implementación a medida los gestiona nuestro equipo directamente.",
    entCta: "Contáctanos",
    faqTitle: "Preguntas de facturación",
    bq1: "¿Caducan los créditos?",
    ba1: "La política de caducidad se está finalizando. Pregúntanos por el formulario de contacto y confirmaremos las condiciones de tu región antes de comprar.",
    bq2: "¿Hay reembolso de créditos no usados?",
    ba2: "La política de reembolso se está finalizando. Contáctanos para conocer las condiciones actuales antes de comprar.",
    bq3: "¿Cómo recargo?",
    ba3: "Compra créditos adicionales en cualquier momento desde tu cuenta — sin mínimo después de la activación inicial de $49.",
    needsInput: "Política pendiente de confirmación",
  },
  contactPage: {
    kicker: "Enterprise",
    title: "Planifiquemos tu despliegue de IA en Salesforce.",
    sub: "Para grandes organizaciones que quieren Bring-Your-Own-Key, contratos a medida o implementación práctica del equipo DulipTech.",
    responseTime: "Nuestro equipo responde en 1 día laborable.",
    fullName: "Nombre completo",
    email: "Email de empresa",
    company: "Empresa",
    jobTitle: "Cargo",
    country: "País / Región",
    companySize: "Tamaño de la empresa",
    sfEdition: "Edición de Salesforce (opcional)",
    useCase: "Cuéntanos tu caso de uso",
    contactMethod: "Método de contacto preferido",
    send: "Enviar consulta",
    success: "Tu email está listo para enviar — responderemos en 1 día laborable.",
    demoTitle: "¿Prefieres una demo en vivo?",
    demoSub: "Nuestro calendario se está configurando — mientras tanto, escríbenos desde el formulario de contacto de arriba.",
    demoKicker: "Reserva una demo",
    demoLead: "Elige el horario que te convenga — un ingeniero de DulipTech te mostrará Gyeno Studio en vivo, en tu contexto.",
    demoScroll: "Agenda una sesión de 30 minutos con un ingeniero de DulipTech.",
    demoCta: "Reservar demo",
    byokTitle: "Bring-Your-Own-Key",
    byokDesc: "Conecta tus contratos enterprise de Claude, OpenAI o Gemini. Tus claves, tus acuerdos de datos, tu control de costes.",
    implTitle: "Implementación a medida",
    implDesc: "Los ingenieros de DulipTech diseñan, construyen y gobiernan tu flota de agentes contigo — del primer caso de uso al despliegue total.",
    secTitle: "Seguridad y gobernanza",
    secDesc: "Los agentes funcionan dentro del modelo de permisos de tu org con Action Runs, Policy Violations y Error Logs totalmente visibles.",
  },
  faqPage: {
    kicker: "FAQ",
    title: "Respuestas, directas.",
    sub: "Todo lo que los equipos Salesforce preguntan antes de empezar.",
    stillQ: "¿Aún tienes preguntas?",
    stillCta: "Contáctanos",
  },
  legal: {
    reviewFlag: "Borrador para revisión — un asesor legal debe revisar este texto antes del lanzamiento público.",
    inputFlag: "Las secciones marcadas [NEEDS BUSINESS INPUT] requieren decisiones de política finales antes del lanzamiento.",
  },
  common: {
    selectPlaceholder: "Seleccionar…",
  },
};

export default es;
